var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.orderList}}),_vm._v(" "),_c('p',{staticClass:"tips"},[_vm._v("注：请尽量提前续费，防止IP回收后无法续费！")]),_vm._v(" "),_c('p',{staticClass:"tips"},[_vm._v("购买成功后，预计需要5-10分钟创建时间。之后，请前往客户端【独享定制】使用已购买的节点。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b618cd7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Personal/components/exclusiveNodeManagement.vue
// module id = oluP
// module chunks = 1